<template>
    <div class="payment-detail-form">
        <InfoContainer
            :infoTitle="formConfig['infoTitle']"
            :contentConfig="formConfig['infoContent']"
        >
            <template #basicInfo>
                <CommonDetail
                    v-if="isDetail"
                    :configArray="addFormConfig"
                    :initValue="formData"
                >                  
                </CommonDetail>
                <avue-form
                    ref="basicInfoForm"
                    v-else
                    v-model="formData"
                    :option="addPrepaymentConfig"
                >
                    <template #projectName>
                        <CommonSelect
                            bindLabel="name"
                            bindKey="id"
                            bindValue="name"
                            dataUrl="bl/blreportstandard/page"
                            methods="get"
                            dataMethod="params"
                            searchKey="name"
                            :initParam="{
                                managerUser:userInfo.user_id
                            }"
                            :bindId="selectProjectId?selectProjectId:''"
                            @handleChange="setProjectInfo"
                        />
                    </template>

                    <template #contractName>
                        <CommonSelect
                            bindLabel="contractName"
                            bindKey="id"
                            bindValue="contractName"
                            dataUrl="bl/blcontractmanage/page"
                            methods="get"
                            dataMethod="params"
                            searchKey="contractName"
                            :initParam="contractParam"
                            :bindId="selectContractId?selectContractId:''"
                            @handleChange="setContractInfo"
                        />
                    </template>
                </avue-form>
            </template>

            <!-- 还款信息 -->
            <template #repaymentInfo>
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%;margin-bottom: 20px;"
                >
                    <el-table-column
                        align="center"
                        label= "批次"
                        property="investBatch"
                    >
                        <template slot-scope="{ row }">
                            第{{row.investBatch}}批
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label= "笔数"
                        property="paymentBatch"
                    >
                        <template slot-scope="{ row }">
                            第{{row.paymentBatch}}笔
                        </template>
                    </el-table-column>                    
                    <el-table-column
                        align="center"
                        property="issue"
                        label="期数"
                    >
                        <template slot-scope="{ row }">
                            <div>第{{row.issue}}期</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="rentDay"
                        label="还款日"
                        width="150"
                    >
                        <template slot-scope="{ row }">
                            {{`${String(row.rentDay).substring(0,4)}-${String(row.rentDay).substring(4,6)}-${String(row.rentDay).substring(6,8)}`}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="cashFlow"
                        label="每期应还"
                        width="150"
                    >
                        <template slot-scope="{ row }">
                            {{getMoney(Number(row.cashFlow))}}元
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="principal"
                        label="每期本金"
                        width="150"
                    >
                        <template slot-scope="{ row }">
                            {{getMoney(Number(row.principal))}}元
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="interest"
                        label="每期利息"
                        width="150"
                    >
                        <template slot-scope="{ row }">
                            {{getMoney(Number(row.interest))}}元
                        </template>                    
                    </el-table-column>

                    <el-table-column
                        align="center"
                        property="remarks"
                        label="备注"
                        width="150"
                    >
                    </el-table-column>
                </el-table>                
                <CommonDetail
                    v-if="isDetail"
                    :configArray="extraFormConfig"
                    :initValue="formData"
                >                  
                </CommonDetail>
                <avue-form
                    ref="extraInfoForm"
                    v-else
                    v-model="formData"
                    :option="extraPrepaymentConfig"
                >
                </avue-form>                
            </template>
        </InfoContainer>
    </div>
</template>
<script>
import {
    addPrepaymentConfig,
    extraPrepaymentConfig,
    addFormConfig,
    extraFormConfig
} from "../prepaymentConfig"
import Accessory from "@/components/accessoriesother/accessory"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock"
import CommonDetail from "@/components/commonDetail/commonDetail"
import InfoContainer from "@/components/infoContainer/infoContainer"
import {queryPrepaymentDetail, queryPlanList} from "@/api/factoring/factoring"
import { mapGetters } from "vuex";
export default {
    name: 'PrepaymentDetailForm',
    data() {
        return {
            
            formData: {},
            selectProjectId: '',
            selectContractId: '',
            contractParam: {},
            tableData: [],
            addPrepaymentConfig: addPrepaymentConfig(),
            extraPrepaymentConfig: extraPrepaymentConfig(this.getRepaymentInfo),
            addFormConfig: addFormConfig(),
            extraFormConfig: extraFormConfig(),
            formConfig: {
                infoTitle: '提前还款',
                infoContent: [{
                    title: '项目信息',
                    prop: 'basicInfo'
                },{
                    title: '还款信息',
                    prop: 'repaymentInfo'
                }]
            }
        }
    },
    components: {
        Accessory,
        CommonSelect,
        CommentBlock,
        CommonDetail,
        InfoContainer
    },
    watch: {
        'formData.principal': {
            handler(newValue, oldValue) {
                this.formData.principalStr = this.changeNumMoneyToChinese(Number(newValue))
                this.formData.realReturn = this.getMoney(Number(newValue) + Number(this.formData.interest?this.formData.interest:0))
                this.formData.totalAmount = Number(newValue) + Number(this.formData.interest?this.formData.interest:0)
            },
            deep: true
        },
        'formData.interest': {
            handler(newValue, oldValue) {
                this.formData.interestStr = this.changeNumMoneyToChinese(Number(newValue))
                this.formData.realReturn = this.getMoney(Number(newValue) + Number(this.formData.principal?this.formData.principal:0))
                this.formData.totalAmount = Number(newValue) + Number(this.formData.principal?this.formData.principal:0)
            },
            deep: true
        },
        'initData': {
            handler(newObj, oldObj) {
                if(JSON.stringify(newObj) != "{}") {
                    this.setFormData(newObj)
                }
            }
        }
    },
    props: {
        id: {
            type:String,
            default: ''
        },
        isDetail: {
            type: Boolean,
            default: false
        },
        // 传入的详细数据
        initData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    mounted() {

    },
    methods: {
        setFormData(data) {
            this.tableData = data.calc.rentplans
            let setData = {}
            this.selectProjectId = data.projectInfoId
            this.selectContractId = data.conManageId
            setData.projectName = data.projectName
            setData.projectInfoId = data.projectInfoId
            setData.contractName = data.contractName
            setData.contractId = data.conManageId
            // 测算归还本金
            setData.calcPrincipal = this.getMoney(Number(data.calc.principal))
            // 测算归还利息
            setData.calcInterest = this.getMoney(Number(data.calc.interest))
            // 客户名称
            setData.sellerCustName = data.sellerCustName
            // 协办
            setData.assistUser = data.assistUser
            setData.assistUserName = data.assistUserStr
            // 主办
            setData.managerUser = data.managerUser
            setData.managerUserName = data.managerUserStr
            // 部门
            setData.managerDept = data.managerDept
            // 预计还款日
            setData.prepaymentDate = data.prepaymentDate
            // 保证金抵扣金额
            setData.depositDeductionAmount = data.depositDeductionAmount
            setData.depositDeductionAmountStr = this.getMoney(Number(data.depositDeductionAmount))
            // 实际归还本金
            setData.principal = data.principal
            setData.principalChange = this.getMoney(Number(data.principal))
            // 实际归还利息
            setData.interest = data.interest
            setData.interestChange = this.getMoney(Number(data.interest))
            // 实际归还金额
            setData.realReturnStr = this.getMoney(Number(data.principal) + Number(data.interest))

            this.formData = setData

            this.$forceUpdate()
        },

        async getRepaymentInfo(date) {
            const params = {
                contractId: this.formData.contractId,
                paymentDate: date
            }
            let res = await queryPlanList(params)
            if(res.data.code == 200) {
                // 测算归还本金
                this.formData.calcPrincipal = this.getMoney(Number(res.data.data.principal))
                this.formData.calcInterest = this.getMoney(Number(res.data.data.interest))
            }
        },
        async queryPrepaymentDetail(id) {
            let res = await queryPrepaymentDetail({ id })
            if(res.data.code == 200) {
                this.$forceUpdate()
            }
        },

        setProjectInfo(data) {
            if(data && JSON.stringify(data) != '{}') {
                this.$emit("setBasicInfoData",data)
                this.formData.projectInfoId = data.id
                this.formData.projectName = data.name
                this.contractParam = {reportId: data.id, 
                    // isInvest: 1, 
                    listScene:'prepayment'}
            }else {
                this.clearData()
            }

        },

        setContractInfo(data) {
            if(data && JSON.stringify(data) != '{}') {
                this.formData.contractId = data.id
                this.formData.contractName = data.contractName
                // 内部收益率
                this.formData.xirr = data.xirr
                this.formData.xirrStr = `${(Number(data.xirr)*100).toFixed(4)}%`
                this.formData.sellerCustName = data.sellerCustName
                // 客户名称
                this.formData.sellerCustName = data.sellerCustName
                // 协办
                this.formData.assistUser = data.assistUser
                this.formData.assistUserName = data.assistUserName
                // 主办
                this.formData.managerUser = data.managerUser
                this.formData.managerUserName = data.managerUserName
                // 部门
                this.formData.managerDept = data.managerDept
                
                // 查询还款信息
                this.queryRepaymentTableData(data.id)
            }
        },

        async queryRepaymentTableData(id) {
            let res = await queryPlanList({contractId: id})
            if(res.data.code == 200) {
                this.tableData = res.data.data.rentplans
            }
        },

        clearData() {
            this.formData.tableData = []
            this.formData.contractId = ''
            this.formData.contractName = ''
            // 内部收益率
            this.formData.xirr = ''
            this.formData.xirrStr = ''

            this.formData.sellerCustName = ''
            // 客户名称
            this.formData.sellerCustName = ''
            // 协办
            this.formData.assistUserName = ''
            // 主办
            this.formData.managerUserName = ''
        },

        validForm() {
            let self = this
            return new Promise((resolve, reject) => {
                self.$refs.basicInfoForm.validate((valid, done) => {
                    done()
                    if(valid) {
                        self.$refs.extraInfoForm.validate((valids, dones) => {
                            dones()
                            if(valids) {
                                resolve({result: true, formData:self.formData})
                            }
                        }, errs => {
                            resolve({result: false})
                            self.$message.warning('请补全还款信息')
                        })
                    }
                }, err => {
                    resolve({result: false})
                    self.$message.warning('请补全项目信息')
                })
            })
        },
    }
}
</script>
<style lang="scss" scoped>

</style>